function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { ActionButton, StepLayout } from "../../BusinessOnboardingWidget.utils";
import { useOverlayContext } from 'seagull';
import BrandLogoIcon from "./BrandLogoIcon";
import { ClientPreview } from "../../../../../components/ClientPreview/ClientPreview";
import { useFetchOnMountIfDataStale } from "../../../../../hooks/useFetchOnMountIfDataStale";
import { useStoreActions } from "../../../../../contexts";
export default function SetUpBrand() {
  const overlayContext = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const {
    data: legalTerms
  } = useFetchOnMountIfDataStale(state => state.legalTerms, actions => actions.fetchLegalTerms());
  return /*#__PURE__*/React.createElement(StepLayout, {
    id: "setupBrand",
    title: "Align the look and feel of your proposals with your brand",
    subtitle: "Strengthen your Brand and customize the customer journey from the first interaction by adding your logo and brand colors to your proposals.",
    actions: /*#__PURE__*/React.createElement(ActionButton, {
      "data-testid": "onboarding-widget-setup-brand",
      loading: !legalTerms,
      loadingText: "Set up brand",
      onClick: () => {
        if (!legalTerms) return;
        logBI(11217);
        overlayContext.showModal({
          content: props => /*#__PURE__*/React.createElement(ClientPreview, _extends({
            type: "setupBrand",
            setupBrandInfo: {
              legalTerms
            }
          }, props))
        });
      }
    }, "Set up brand"),
    icon: /*#__PURE__*/React.createElement(BrandLogoIcon, null)
  });
}